import { DatePipe, NgIf } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { FuseAlertComponent } from '@fuse/components/alert';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { LollySchedulerService } from 'app/services/lolly-scheduler.service';
import { SnackbarService } from 'app/services/snackbar.service';
import { NgxLoadingModule } from 'ngx-loading';
import { ErrorPageComponent } from '../error-page/error-page.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, NgModel } from '@angular/forms';
import { environment } from 'environments/environment';
import { LollyBooking } from 'app/models/bookings.model';

@Component({
  selector: 'app-booking-approve',
  standalone: true,
  imports: [MatIconModule, FuseAlertComponent, DatePipe, NgxLoadingModule, NgIf,ErrorPageComponent,MatInputModule, MatButtonModule, MatDialogActions, MatDialogContent,FormsModule],
  templateUrl: './booking-approve.component.html',
  styleUrl: './booking-approve.component.scss'
})
export class BookingApproveComponent {
  id: string = null;
  bookingData: LollyBooking = new LollyBooking()
  loading: boolean = false;
  error:string = null;
  dialogRef!: MatDialogRef<any>;
  cancelPayload = { content: "", subject: "" }
  BookingViewState : 'error' | 'confirm' | 'confirmed' | 'cancelled' = null;

  constructor(private _fuseConfirmationService: FuseConfirmationService,
    private _lollySchedulerService: LollySchedulerService,
    private route: ActivatedRoute,
    private router: Router,
    private _snackbarService: SnackbarService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id')!;
      if (this.id) {
        this.loadBookingData();
      }
    });
  }

  loadBookingData() {
    this.loading = true;
    this._lollySchedulerService.getBookingData(this.id).then(res => {
      this.bookingData = this._lollySchedulerService.getData(res);
      this.BookingViewState = 'confirm';
    }).catch(error => {
      this.BookingViewState = 'error'
      this.error = error?.message ?? "Something went wrong"; 
    }).finally(() => {
      this.loading = false;
    })
  }

  onConfirm() {
    const confirmation = this._fuseConfirmationService.open({
      title: 'Confirm Booking',
      message: `You are about to confirm the booking.`,
      actions: {
        confirm: {
          label: 'Yes, Confirm Booking',
          color: 'primary',
        },
      },
      icon: {
        color: 'primary',
        name: 'heroicons_outline:check-circle',
      },
    });

    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        this.confirmBooking()
      }
    });
  }

  confirmBooking() {
    this.loading = true;
    this._lollySchedulerService
      .confirmBooking({}, this.id)
      .then((res) => {
        this._snackbarService.successSnackbar(
          'Booking confirmed successfully!'
        );
        this.BookingViewState = 'confirmed'
      })
      .catch((err) => {
        this.BookingViewState = 'error'
        this.error = err?.message ?? "Something went wrong"; 
      }).finally(() => {
        this.loading = false;
      });
  }

  loadBookingPage() {
    window.location.href = `/bookings/${this.bookingData.account_session_uuid}`
  }

   openDialog(templateRef: TemplateRef<any>): void {
      this.dialogRef = this.dialog.open(templateRef, {
        width: '600px',
      });
    }

    cancelBooking() {
      this.loading = true;
      this._lollySchedulerService
        .cancelBooking(this.cancelPayload, this.id)
        .then((res) => {
          this._snackbarService.successSnackbar(
            'Booking cancelled successfully!'
          );
         this.BookingViewState= 'cancelled'
          this.dialogRef.close()
        })
        .catch((err) => {
          this.error = err?.message ?? "Something went wrong"; 
          this.dialogRef.close()
          this.BookingViewState = 'error'
          console.log(err);
        }).finally(() => {
          this.loading = false;
        });
    }

    viewBookingRequest(){
      window.open(environment.lollyLawAppLink + 'scheduler/bookings','_self');
    }

    navigateToReschedule(){
      this.router.navigate(['/rescheduling/', this.bookingData.uuid]);
    }
   
}
